import { buildImgixUrl } from "@/lib";
import { useAppSelector } from "@/redux/store/hooks";

const Logo = () => {
  const { site } = useAppSelector((state) => state.site);

  return (
    <div className="logo">
      {!!site.logoUrl && (
        <a href="/">
          <img
            alt={site.name}
            src={buildImgixUrl(site.logoUrl)}
            className="logo__image"
          />
        </a>
      )}
    </div>
  );
};

export default Logo;
